import { ContentHeader, Css, useTestIds } from "@homebound/beam";
import camelCase from "lodash/camelCase";
import { ReactNode } from "react";

type ReviewImpactSectionProps = {
  title: string;
  description?: ReactNode;
  /**
   * Set when the content is a full-width table. Tables space their own edges with `withColumnGutters`
   * and can scroll the page sideways, so the section drops its padding and grows to the table's width
   * to keep the sticky header lined up.
   */
  fullBleed?: boolean;
  children?: ReactNode;
};

/** One titled section of the Review Impact step: a `ContentHeader` above its content. */
export function ReviewImpactSection(props: ReviewImpactSectionProps) {
  const { title, description, fullBleed = false, children } = props;
  const tid = useTestIds(props, `${camelCase(title)}Section`);

  return (
    <div css={{ ...Css.df.fdc.gap3.px3.$, ...(fullBleed ? Css.mw("fit-content").$ : {}) }} {...tid}>
      {/* `ContentHeader` brings its own horizontal padding, so only the content below needs it. */}
      <ContentHeader title={title} description={description} />
      {children && (fullBleed ? children : <div css={Css.$}>{children}</div>)}
    </div>
  );
}
